import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { LetDirective } from '@ngrx/component';

import { CoreFacade } from '@lockton-apps/shared/data-access/core';
import {
  FeedbackService,
  RlaGuards,
  UiModule,
} from '@lockton-apps/shared/ui/lui';
import {
  bottomBar,
  BottomBarService,
} from '@lockton-apps/shared/util/bottom-bar';
import { PortalModule } from '@angular/cdk/portal';
import { LAYOUT_CONFIG, LayoutConfig } from '../layout-config';

@Component({
    selector: 'lib-layout-auth',
    imports: [
        CommonModule,
        UiModule,
        MatMenuModule,
        MatIconModule,
        RouterModule,
        LetDirective,
        PortalModule,
    ],
    templateUrl: './layout-auth.component.html',
    styleUrls: ['./layout-auth.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [bottomBar]
})
export class LayoutAuthComponent {
  footerLinks$ = this.coreFacade.footerNav$;

  loading$ = this.feedbackService.loadingOverlay$;

  rlaGuards = RlaGuards;

  copyright: string;

  constructor(
    private coreFacade: CoreFacade,
    private feedbackService: FeedbackService,
    @Inject(LAYOUT_CONFIG) layoutConfig: LayoutConfig,
    public bottomBarService: BottomBarService
  ) {
    this.copyright = layoutConfig.copyright || 'Lockton Companies LLP E&OE';
  }
}
